import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
// 監聽購物車是否打開，影響 chatbot 顯示
export class CartStateService {
  private cartOpenSubject = new BehaviorSubject<boolean>(false);
  
  get isCartOpen$(): Observable<boolean> {
    return this.cartOpenSubject.asObservable();
  }
  
  setCartOpen(isOpen: boolean): void {
    this.cartOpenSubject.next(isOpen);
  }
}